import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-addcontacts',
  templateUrl: './addcontacts.component.html',
  styleUrls: ['./addcontacts.component.less']
})
export class AddcontactsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
